<template>
  <div class="page_container wareRecordDetailPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/recordIndex/wRecordIndex' }"
          >入库操作追溯记录</el-breadcrumb-item
        >
        <el-breadcrumb-item>操作记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="form_container">
      <!-- <h1>操作记录</h1> -->
      <div class="content_wrap flex-between">
        <div class="shop_wrap">
          <div class="block">
            <p>
              商品ID：<span>{{ detail.cm.id }}</span>
            </p>
          </div>
          <div class="block">
            <p>商品名称：</p>
            <p>
              <span>{{ detail.cm.commodityname }}</span>
            </p>
            <p>
              <span>{{ detail.cm.commodityname_e }}</span>
            </p>
            <p>
              <span>{{ detail.cm.commodityname_y }}</span>
            </p>
            <p>
              <span>{{ detail.cm.commodityname_m }}</span>
            </p>
            <p>
              <span>{{ detail.cm.commodityname_t }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              SKU采购编码：<span>{{ detail.cm.sku }}</span>
            </p>
            <p>
              记录类型：<span>{{ detail.actnamestr }}</span>
            </p>
            <p>
              变动原因：<span>{{ detail.actreasonidstr }}</span>
            </p>
            <!-- <p>
              ISBN编码： <span>{{ detail.cm.ISBN }}</span>
            </p> -->
          </div>
        </div>
        <div class="shop_wrap">
          <div class="block">
            <p>
              入库数量：<span class="red">{{ detail.num }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              入库商品属性标签：<span class="red">{{
                detail.ams_shop_commodity_attrid_str
              }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              入库商品属性值：<span class="red">{{
                detail.ams_shop_commodity_attr_value_str
              }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              入库收货物流类型记录：<span class="red">{{ detail.wsid }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              入库收货物流单号记录：<span class="red">{{ detail.wsno }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              备注信息记录：<span class="red">{{ detail.reason }}</span>
            </p>
          </div>
        </div>
        <div class="shop_wrap">
          <div class="block">
            <p>入库位置：</p>
            <p v-if="detail.whid1_str">
              <span class="red">{{ detail.whid1_str }}</span>
            </p>
            <p v-if="detail.whid2_str">
              <span class="red">{{ detail.whid2_str }}，</span>
            </p>
            <p v-if="detail.whid3_str">
              <span class="red">{{ detail.whid3_str }}，</span>
            </p>
            <p v-if="detail.whid4_str">
              <span class="red">{{ detail.whid4_str }}</span>
            </p>
          </div>

          <div class="block">
            <p>入库商品批次记录：</p>
            <p>
              <span class="red">{{ detail.makerno }}</span>
            </p>
          </div>
          <div class="block">
            <p>入库商品生产商记录：</p>
            <p>
              <span class="red">{{ detail.makername_str }}</span>
            </p>
          </div>

          <div class="block">
            <p>操作日期：</p>
            <p>
              <span class="red">{{ detail.createdate | formatDate }}</span>
            </p>
          </div>
          <div class="block">
            <p>操作人员：</p>
            <p>
              <span class="red">{{ detail.userman }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
  </div>
</template>

<script>
import storage from "../../utils/storage";

export default {
  name: "wRecordDetail",
  data() {
    return {
      detail: "",
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    this.detail = storage.get("DETAILITEM");
  },
  methods: {
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.wareRecordDetailPage {
  .content_wrap {
    .shop_wrap {
      width: calc(100% / 3);
      p {
        color: #404d6c;
      }
      .red {
        color: #f40728;
      }
    }
    .record_wrap {
      flex: 1;
      p {
        color: #444;
      }
      .red {
        color: #f40728;
      }
    }
    .block {
      margin-bottom: 25px;
    }
  }
}
</style>